import styled from 'styled-components'

export const DesktopContentWrapper = styled.div`
  background: white;
  overflow: hidden;
  transition: max-height 300ms ease-out;
  max-height: ${({ isOpen }) => (isOpen ? '200px;' : '0px')};
`
